import React from "react";
import "./ScheduleEditor.css";

const DAYS_OF_WEEK = [
  { value: 0, label: "Monday" },
  { value: 1, label: "Tuesday" },
  { value: 2, label: "Wednesday" },
  { value: 3, label: "Thursday" },
  { value: 4, label: "Friday" },
  { value: 5, label: "Saturday" },
  { value: 6, label: "Sunday" },
];

const FREQUENCY_PRESETS = [
  { label: "Daily", intervalDays: 1 },
  { label: "Weekly", intervalDays: 7 },
  { label: "Every 2 weeks", intervalDays: 14 },
  { label: "Monthly", intervalDays: 30 },
  { label: "Custom", intervalDays: null },
];

// Decide which preset label matches the current intervalDays.
function labelFor(intervalDays) {
  const preset = FREQUENCY_PRESETS.find((p) => p.intervalDays === intervalDays);
  return preset ? preset.label : "Custom";
}

export default function ScheduleEditor({ value, onChange }) {
  const { intervalDays = 7, dayOfWeek = 0, dayOfMonth = 1 } = value || {};
  const label = labelFor(intervalDays);

  const handleFrequencyChange = (e) => {
    const next = e.target.value;
    const preset = FREQUENCY_PRESETS.find((p) => p.label === next);
    if (preset && preset.intervalDays != null) {
      onChange({ ...value, intervalDays: preset.intervalDays });
    } else {
      onChange({ ...value, intervalDays: 3 }); // default custom
    }
  };

  return (
    <div className="schedule-editor">
      <label className="schedule-field">
        <span className="schedule-field-label">Frequency</span>
        <select value={label} onChange={handleFrequencyChange}>
          {FREQUENCY_PRESETS.map((p) => (
            <option key={p.label} value={p.label}>{p.label}</option>
          ))}
        </select>
      </label>

      {(intervalDays === 7 || intervalDays === 14) && (
        <label className="schedule-field">
          <span className="schedule-field-label">Day of week</span>
          <select
            value={dayOfWeek}
            onChange={(e) => onChange({ ...value, dayOfWeek: parseInt(e.target.value, 10) })}
          >
            {DAYS_OF_WEEK.map((d) => (
              <option key={d.value} value={d.value}>{d.label}</option>
            ))}
          </select>
        </label>
      )}

      {intervalDays === 30 && (
        <label className="schedule-field">
          <span className="schedule-field-label">Day of month</span>
          <input
            type="number" min="1" max="28" value={dayOfMonth}
            onChange={(e) => {
              const n = Math.max(1, Math.min(28, parseInt(e.target.value || "1", 10)));
              onChange({ ...value, dayOfMonth: n });
            }}
          />
        </label>
      )}

      {label === "Custom" && (
        <label className="schedule-field">
          <span className="schedule-field-label">Run every (days)</span>
          <input
            type="number" min="1" max="30" value={intervalDays}
            onChange={(e) => {
              const n = Math.max(1, Math.min(30, parseInt(e.target.value || "1", 10)));
              onChange({ ...value, intervalDays: n });
            }}
          />
        </label>
      )}

      <div className="schedule-footnote">Runs at 12:00 AM MST.</div>
    </div>
  );
}
